import script from "./UserOverviewStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./UserOverviewStatistics.vue?vue&type=script&setup=true&lang=js"

import "./UserOverviewStatistics.vue?vue&type=style&index=0&id=70de63f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70de63f4"]])

export default __exports__